import { ArrowRight, Mail } from "lucide-react";
import Reveal from "@/components/Reveal";
import { CONTACT } from "@/lib/constants";
import { useConnectModal } from "@/context/ConnectModalContext";

export default function FinalCTA({ title = "Bring us the problem you have not been able to hand to one team.", lead = "Start with a conversation about where growth is constrained. We take on a limited number of engagements and begin with research, not a proposal template." }) {
  const { openConnectModal } = useConnectModal();
  return (
    <section className="hp-section hp-surface-stone hp-grain-light border-t border-slate-200" data-testid="final-cta">
      <div className="hop-container relative z-10">
        <Reveal>
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <h2 className="hp-h2 text-hop-blue">{title}</h2>
              <p className="hp-lead mt-5" style={{ color: "#3c4768" }}>{lead}</p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3 sm:flex-row lg:flex-col">
              <button type="button" onClick={openConnectModal} className="hp-btn hp-btn-primary">
                Request an executive conversation <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </button>
              <a href={CONTACT.emailHref} className="hp-btn hp-btn-ghost"><Mail className="w-4 h-4" aria-hidden="true" /> {CONTACT.email}</a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
